(function () {
            var track = document.getElementById('slider-track');
            if (!track) return;
            var dots = document.querySelectorAll('.gallery-dot');
            var prevBtn = document.getElementById('slider-prev');
            var nextBtn = document.getElementById('slider-next');
            var domSlides = track.children.length || 1;
            var declared = (typeof wp_total_images !== 'undefined' && wp_total_images > 0)
                ? wp_total_images
                : (window.product_data && window.product_data.images && window.product_data.images.length)
                    ? window.product_data.images.length
                    : domSlides;
            var totalSlides = Math.max(1, Math.min(declared, domSlides));
            var current = 0;
            var startX = 0;
            var isDragging = false;
            function goTo(idx) {
                current = (idx + totalSlides) % totalSlides;
                track.style.transform = 'translateX(-' + current * 100 + '%)';
                dots.forEach(function (d, i) {
                    d.classList.toggle('bg-primary', i === current);
                    d.classList.toggle('bg-stone', i !== current);
                });
            }
            if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
            if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
            dots.forEach(function (d) {
                d.addEventListener('click', function () { goTo(parseInt(d.dataset.idx, 10) || 0); });
            });
            track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
            track.addEventListener('touchend', function (e) {
                if (!isDragging) return;
                var diff = startX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
                isDragging = false;
            }, { passive: true });
        })();
        var ReviewSlider = (function () {
            var currentIndex = 0, reviewImages = [], touchStartX = 0, touchStartY = 0;
            function sliderEl() { return document.getElementById('review-slider'); }
            function init() {
                var slider = sliderEl();
                if (!slider) return;
                reviewImages = document.querySelectorAll('.review-img');
                reviewImages.forEach(function (item, index) { item.addEventListener('click', function () { open(index); }); });
                document.addEventListener('keydown', function (e) {
                    if (!slider.classList.contains('active')) return;
                    if (e.key === 'Escape') close();
                    if (e.key === 'ArrowLeft') prev();
                    if (e.key === 'ArrowRight') next();
                });
                slider.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; touchStartY = e.changedTouches[0].screenY; }, { passive: true });
                slider.addEventListener('touchend', function (e) {
                    var diffX = touchStartX - e.changedTouches[0].screenX;
                    var diffY = touchStartY - e.changedTouches[0].screenY;
                    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
                        if (diffX > 0) next(); else prev();
                    } else if (diffY < -80) close();
                }, { passive: true });
            }
            function generateStars(count) {
                var html = '';
                for (var i = 0; i < 5; i++) {
                    var color = i < count ? '#fbbf24' : '#4b5563';
                    html += '<i class="fas fa-star" style="color:' + color + '"></i>';
                }
                return html;
            }
            function update() {
                if (!reviewImages.length) return;
                var item = reviewImages[currentIndex];
                var img = item && item.querySelector('img');
                var imageEl = document.getElementById('slider-image');
                var userEl = document.getElementById('slider-user');
                var ratingEl = document.getElementById('slider-rating');
                var counterEl = document.getElementById('slider-counter');
                if (!item || !img || !imageEl || !userEl || !ratingEl || !counterEl) return;
                imageEl.src = img.src;
                userEl.textContent = item.dataset.user || '';
                ratingEl.innerHTML = generateStars(parseInt(item.dataset.rating, 10) || 5);
                counterEl.textContent = (currentIndex + 1) + ' / ' + reviewImages.length;
            }
            function open(index) {
                var slider = sliderEl();
                if (!slider || !reviewImages.length) return;
                currentIndex = Math.max(0, Math.min(index, reviewImages.length - 1));
                update();
                slider.classList.add('active');
                document.body.style.overflow = 'hidden';
            }
            function close() {
                var slider = sliderEl();
                if (!slider) return;
                slider.classList.remove('active');
                document.body.style.overflow = '';
            }
            function prev() {
                if (!reviewImages.length) return;
                currentIndex = (currentIndex - 1 + reviewImages.length) % reviewImages.length;
                update();
            }
            function next() {
                if (!reviewImages.length) return;
                currentIndex = (currentIndex + 1) % reviewImages.length;
                update();
            }
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
            else init();
            return { open: open, close: close, prev: prev, next: next };
        })();
        (function () {
            var faqItems = document.querySelectorAll('.faq-trigger');
            faqItems.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var isOpen = this.dataset.open === 'true';
                    faqItems.forEach(function (b) {
                        b.dataset.open = 'false';
                        if (b.nextElementSibling) b.nextElementSibling.classList.add('hidden');
                        var iconWrap = b.querySelector('.faq-icon');
                        var icon = b.querySelector('i');
                        if (iconWrap) {
                            iconWrap.classList.remove('bg-primary/10');
                            iconWrap.classList.add('bg-stone/50');
                        }
                        if (icon) {
                            icon.classList.remove('fa-minus', 'text-primary');
                            icon.classList.add('fa-plus', 'text-muted');
                        }
                    });
                    if (!isOpen) {
                        this.dataset.open = 'true';
                        if (this.nextElementSibling) this.nextElementSibling.classList.remove('hidden');
                        var openWrap = this.querySelector('.faq-icon');
                        var openIcon = this.querySelector('i');
                        if (openWrap) {
                            openWrap.classList.add('bg-primary/10');
                            openWrap.classList.remove('bg-stone/50');
                        }
                        if (openIcon) {
                            openIcon.classList.add('fa-minus', 'text-primary');
                            openIcon.classList.remove('fa-plus', 'text-muted');
                        }
                    }
                });
            });
        })();
